import { styled } from "styled-components";
const ListboxWrapper = styled("div").attrs({
  role: "listbox"
})(
  ({ theme }) => ({
    backgroundColor: "white",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    boxSizing: "border-box",
    color: theme.color.default,
    display: "flex",
    flexDirection: "column",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    lineHeight: theme.lineHeight.default,
    maxWidth: "100%",
    outline: 0
  }),
  ({ $appearance }) => ({
    none: { borderRadius: 0 },
    neat: { borderRadius: 2 },
    round: { borderRadius: 4 }
  })[$appearance],
  ({ height }) => ({ height }),
  ({ maxHeight }) => ({ maxHeight }),
  ({ width }) => ({ width })
);
const ListboxList = styled("div")(({ search, theme }) => ({
  borderTop: search ? `1px solid ${theme.borderColor}` : "",
  overflow: "auto",
  padding: "4px 0"
}));
const ListboxGroup = styled("section").attrs({
  role: "presentation"
})(
  {
    padding: "0 4px"
  },
  ({ groupVariant, theme }) => ({
    divider: {
      borderBottom: `1px solid ${theme.borderColor}`,
      padding: 4,
      "&:first-child": {
        paddingTop: 0
      },
      "&:last-child": {
        borderBottom: 0,
        paddingBottom: 0
      }
    }
  })[groupVariant]
);
const ListboxGroupHeading = styled("h4").attrs({
  role: "presentation"
})(({ theme }) => ({
  color: theme.color.gray7,
  fontSize: theme.fontSize.sm,
  fontWeight: theme.fontWeight.medium,
  lineHeight: theme.lineHeight.default,
  margin: 0,
  padding: "4px 8px",
  textTransform: "uppercase"
}));
const ListboxHeading = styled("div")(({ theme }) => ({
  color: theme.color.gray7,
  padding: "8px 12px"
}));
const ListboxSearch = styled("div")({
  padding: 2
});
const ListboxVoid = styled("div")(({ theme }) => ({
  borderTop: `1px solid ${theme.borderColor}`,
  color: theme.color.gray6,
  padding: "8px 12px"
}));
export {
  ListboxGroup,
  ListboxGroupHeading,
  ListboxHeading,
  ListboxList,
  ListboxSearch,
  ListboxVoid,
  ListboxWrapper
};
